import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import LoginForm from './components/LoginForm';
import RegisterPrompt from './components/RegisterPrompt';
import SocialLogin from './components/SocialLogin';
import Icon from '../../components/AppIcon';

const Login = () => {
  const location = useLocation();
  const [notificationMessage, setNotificationMessage] = useState(null);

  useEffect(() => {
    if (location?.state?.message) {
      setNotificationMessage({
        text: location?.state?.message,
        type: location?.state?.type || 'info'
      });
      // Clear the message from location state
      window.history?.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Accedi - Vetrine Macerata</title>
        <meta name="description" content="Accedi al tuo account Vetrine Macerata per salvare le tue vetrine preferite e accedere a promozioni esclusive." />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-background via-muted/30 to-background flex items-center justify-center p-4 md:p-6">
        <div className="w-full max-w-md">
          <div className="bg-card rounded-2xl shadow-warm p-6 md:p-8 space-y-6">
            <div className="text-center space-y-2">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
                <Icon name="Store" size={32} className="text-primary" />
              </div>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground">
                Bentornato!
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">
                Accedi per continuare a esplorare le vetrine di Macerata
              </p>
            </div>

            {notificationMessage && (
              <div className={`p-4 rounded-lg border ${
                notificationMessage?.type === 'success' ?'bg-success/10 border-success/20' 
                  : notificationMessage?.type === 'error' ?'bg-destructive/10 border-destructive/20' :'bg-primary/10 border-primary/20'
              }`}>
                <div className="flex items-start gap-3">
                  <Icon 
                    name={notificationMessage?.type === 'success' ? 'CheckCircle' : 'Info'} 
                    size={20} 
                    className={`flex-shrink-0 mt-0.5 ${
                      notificationMessage?.type === 'success' ?'text-success' 
                        : notificationMessage?.type === 'error' ?'text-destructive' :'text-primary'
                    }`} 
                  />
                  <p className={`text-sm whitespace-pre-line ${
                    notificationMessage?.type === 'success' ?'text-success' 
                      : notificationMessage?.type === 'error' ?'text-destructive' :'text-primary'
                  }`}>
                    {notificationMessage?.text}
                  </p>
                </div>
              </div>
            )}

            <LoginForm />
            <SocialLogin />
          </div>

          <div className="mt-6">
            <RegisterPrompt />
          </div>

          <div className="mt-8 text-center">
            <p className="text-xs text-muted-foreground">
              Accedendo, accetti i nostri{' '}
              <button className="text-primary hover:text-primary/80 transition-smooth focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3 rounded px-1">
                Termini di Servizio
              </button>{' '}
              e la{' '}
              <button className="text-primary hover:text-primary/80 transition-smooth focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3 rounded px-1">
                Privacy Policy
              </button>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;